import React from 'react';
import { Stack, Typography } from '@mui/material';
import { VideocamOff } from '@mui/icons-material';

import styles from '../overlaysStyle.module.scss';

export const NotSupported = () => (
  <Stack
    data-testid="camera-overlay-not-supported"
    direction="column"
    spacing={10}
    alignItems="center"
    justifyContent="center"
  >
    <VideocamOff className={styles.defaultIconSize} />
    <Typography variant="h3" className={styles.textSize}>
      Camera is not supported on this browser
    </Typography>
  </Stack>
);
